import { snackShow, updateVehicleNotifications } from 'actions';
import apiSlice from '..';
import { myBidsApiSlice as api, bidsAdapter } from 'services/api/my-bids';
import { salesApiSlice as salesApi, salesAdapter } from 'services/api/sales';

export const notificationsApiSlice = apiSlice.injectEndpoints({
  endpoints: builder => ({
    toggleLocalEnabledNotifications: builder.mutation<{ data: { notifications_enabled: boolean } }, number>({
      query: vehicleId => ({
        method: 'POST',
        url: `/notifications/local/${vehicleId}`
      }),
      onCacheEntryAdded: async (vehicleId, { cacheDataLoaded, dispatch, getState, ...rest }) => {
        try {
          const state: any = getState();
          const user = state.user.user;
          const response = await cacheDataLoaded;
          const previouslyEnabled = !response.data.data.notifications_enabled;

          if (user.role === 'buyer') {
            const { page, perPage, filters } = state.myBids;

            dispatch(
              api.util.updateQueryData(
                'getMyBids',
                {
                  limit: perPage,
                  offset: page,
                  ...filters
                },
                draft => {
                  bidsAdapter.updateOne(draft.rows, {
                    id: vehicleId,
                    changes: {
                      notifications_enabled: response.data.data.notifications_enabled
                    }
                  });
                }
              )
            );
          }

          if (user.role === 'seller') {
            const { page, perPage, filters } = state.mySales;
            dispatch(
              salesApi.util.updateQueryData(
                'getMySales',
                {
                  limit: perPage,
                  offset: page,
                  ...filters
                },
                draft => {
                  salesAdapter.updateOne(draft.rows, {
                    id: vehicleId,
                    changes: {
                      notifications_enabled: response.data.data.notifications_enabled
                    }
                  });
                }
              )
            );
          }

          if (location.pathname === `/vehicles/${vehicleId}/details`) {
            dispatch(updateVehicleNotifications(response.data.data.notifications_enabled));
          }

          dispatch(snackShow({ message: `Notifications ${previouslyEnabled ? 'Disabled' : 'Enabled'}` }));
        } catch (error) {
          console.error('error');
          dispatch(snackShow({ message: 'Server Error', type: 'error' }));
        }
      }
    }),
    allowSmsNotifications: builder.mutation<void, void>({
      query: () => ({
        method: 'POST',
        url: `/notifications/sms/allow`
      })
    })
  }),
  overrideExisting: true
});

export const { useToggleLocalEnabledNotificationsMutation, useAllowSmsNotificationsMutation } = notificationsApiSlice;
